/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import edit from './edit';
var metadata = {
  name: "core/social-links",
  category: "widgets",
  icon: "share",
  attributes: {}
};
import save from './save';
var name = metadata.name;
export { metadata, name };
export var settings = {
  title: __('Social links'),
  description: __('Create a block of links to your social media or external sites'),
  supports: {
    align: ['left', 'center', 'right']
  },
  example: {
    innerBlocks: [{
      name: 'core/social-link-wordpress',
      attributes: {
        url: 'https://wordpress.org'
      }
    }, {
      name: 'core/social-link-facebook',
      attributes: {
        url: 'https://www.facebook.com/WordPress/'
      }
    }, {
      name: 'core/social-link-twitter',
      attributes: {
        url: 'https://twitter.com/WordPress'
      }
    }]
  },
  styles: [{
    name: 'default',
    label: __('Default'),
    isDefault: true
  }, {
    name: 'logos-only',
    label: __('Logos Only')
  }, {
    name: 'pill-shape',
    label: __('Pill Shape')
  }],
  edit: edit,
  save: save
};
//# sourceMappingURL=index.js.map